module.exports = __webpack_public_path__ + "static/media/puzzle-8-bg.abc2d898.svg";